import {
  EditOutlined,
  // SaveOutlined
} from "@ant-design/icons";
import { Input, Modal, Form, Spin, notification, Button } from "antd";
import { Row, Col, Label } from "reactstrap";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";

import CancelAction from "../../Tools/CancelAction";
import { useAuth } from "../../context/auth";

const ActionModalPassword = ({ visiblePassword, onCancel, onOk }) => {
  const { accessToken } = useAuth();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [hideNav, setHideNav] = useState(false);
  const [changed, setChange] = useState(false);
  const [newPass, setNewPass] = useState("");
  const [conPass, setConPass] = useState("");

  const [openModalCancelAction, setOpenModalCancelAction] = useState(false);

  const save = async (values) => {
    const url = new URL('/api/user/self', window.location);

    const res = await fetch(url, {
      method: 'PATCH',
      headers: { 'X-ACCESS-TOKEN': accessToken },
      body: JSON.stringify({
        currentPass: values.current,
        pass: values.newPassword,
      }),
    });
    if (res.ok) {
      Swal.fire({
        icon: "success",
        title: "Success !",
        text: "Successfully saved data.",
        showConfirmButton: false,
        timer: 1500,
      });
      onOk();
    } else {
      const { message } = await res.json();
      switch (message) {
        case 'currentPass':
          Swal.fire({
            icon: "error",
            title: "Failed !",
            text: "Enter a valid password and try again.",
            showConfirmButton: false,
            timer: 1500,
          });
          break;

        default:
          notification["error"]({
            message: "Something went wrong !",
            description: `Please re-login or contact web admin. (Code: ${message})`,
          });
          break;
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    // getMemberLandlord();

    setNewPass(getFieldValue("newPassword"));
    setConPass(getFieldValue("conNewPassword"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setHideNav(window.innerWidth <= 1000);
  }, []);
  const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
  const thaiRegex = new RegExp("^(?=.*[ก-๏])");

  const { getFieldValue } = form;

  const NewPassWord = () => {
    setNewPass(getFieldValue("newPassword"));
  };
  const ConPassWord = () => {
    setConPass(getFieldValue("conNewPassword"));
  };

  const pass =
    newPass & (conPass === null) ||
      conPass === undefined ||
      conPass === "" ? null : newPass === conPass ? (
        <>
          <Label
            style={{ color: "#4CAF50", position: "absolute", marginTop: -25 }}
          >
            Passwords match
          </Label>
        </>
      ) : null;

  return (
    <>
      <Modal
        open={visiblePassword}
        title={
          <div className="flex items-center">
            <EditOutlined />
            &nbsp;&nbsp;
            <span>Change password</span>
          </div>
        }
        width={hideNav ? "70%" : "40%"}
        onCancel={() => {
          if (changed) {
            setOpenModalCancelAction(true);
          } else {
            setOpenModalCancelAction(false);
            onCancel();
          }
        }}
        footer={
          <div className="w-full text-center mb-4 flex justify-center">
            <Button
              className="w-36"
              type="primary"
              ghost
              key="cancel"
              shape="round"
              onClick={() => {
                if (changed) {
                  setOpenModalCancelAction(true);
                } else {
                  form.resetFields();
                  setOpenModalCancelAction(false);
                  onCancel();
                }
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                form.validateFields().then((values) => {
                  save(values);
                });
              }}
              className="w-36"
              key="save"
              type="primary"
              shape="round"
              loading={loading}
            >
              Save
            </Button>
          </div>
        }
      >
        <Spin spinning={loading} tip="Loading...">
          <Form
            onFieldsChange={(_, allFields) => {
              if (allFields.length > 0) {
                setChange(true);
              }
            }}
            form={form}
            name="charger-management"
            //className="price"
            layout="vertical"
          >
            <Row>
              <Col lg="11">
                <Form.Item
                  label="Current"
                  colon={false}
                  name="current"
                  rules={[
                    {
                      required: true,
                      message: "Current is required.",
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="Current"
                    maxLength={50}
                    allowClear
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col lg="11">
                <Form.Item
                  label="New Password"
                  colon={false}
                  name="newPassword"
                  dependencies={["password"]}
                  rules={[
                    {
                      required: true,
                      message: "New password is required.",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (strongRegex.test(value) === true) {
                          return Promise.resolve();
                        } else if (thaiRegex.test(value) === true) {
                          return Promise.reject(
                            new Error(
                              "Your password can not use Thai Language."
                            )
                          );
                        }
                        return Promise.reject(
                          new Error(
                            "Your password must be at least 8 characters. It consists of uppercase, lowercase, and numbers."
                          )
                        );
                      },
                    }),
                  ]}
                  onChange={NewPassWord}
                >
                  <Input.Password
                    placeholder="New Password"
                    maxLength={50}
                    allowClear
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col lg="11">
                <Form.Item
                  label="Confirm new password"
                  colon={false}
                  name="conNewPassword"
                  dependencies={["password"]}
                  //hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Confirm new password is required.",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        setConPass(getFieldValue("conNewPassword"));
                        if (!value || getFieldValue("newPassword") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Password do not match")
                        );
                      },
                    }),
                  ]}
                  onChange={ConPassWord}
                >
                  <Input.Password
                    placeholder="Confirm new password"
                    maxLength={50}
                    allowClear
                  />
                </Form.Item>
                {pass}
                {/* {newPass & getFieldValue('conNewPassword') === null ||
                getFieldValue('conNewPassword') === undefined ||
                getFieldValue('conNewPassword') ===""  ? null:
                (newPass === getFieldValue('conNewPassword')
                 ?(<>
                  <Label style={{color:"#4CAF50", position:"fixed", marginTop:-100}}>Passwords match</Label>
                </>):(null))} */}
              </Col>
            </Row>

            <Row></Row>
          </Form>
        </Spin>
      </Modal>
      <CancelAction
        openModalCancelAction={openModalCancelAction}
        onOk={() => {
          setChange(false);
          onCancel();
          form.resetFields();
        }}
        onCancel={() => {
          setOpenModalCancelAction(false);
        }}
      />
    </>
  );
};

export default ActionModalPassword;
